
import { v4 as uuidv4 } from 'uuid';
import {persistOpportunity, defaultOpportunityListing, defaultOpportunityRules, defaultOpportunityState, formatContact, persistThird} from "api/opportunityform"
import { persistCustomFields } from 'api/third';
import ContactApi from 'api/contacts';
import Third from 'stores/forms/third';
import CompanyApi from "api/companies"
import {
    addressState,
    addressGetters,
    addressMutations,
    addressActions,
    persistAddresses,
} from "./addressHelpers";

export default{
    namespaced: true,
    state(){
        return {
            ...Third.state(),
            sideParams: {
                note: true,
                idCode: true,
                staffs: true,
            },
            loading: false,
            modulesSearch: false,
            percentageFunnel: false,
            rules : defaultOpportunityRules(),
            addressSection : addressState(),
            listings : defaultOpportunityListing(),
            ...defaultOpportunityState()
        }
    },
    getters: {
        ...addressGetters,
        ...Third.getters,
        getState: (state, getters) => {
            return {
                opportunitySettings : {...state.opportunitySettings},
                companySettings : {...state.company},
                paramsSettings : {...state.paramsSettings},
                addresses: [{settings:{...state.company.address}}],
                contacts : [...state.contacts],
                contactsList: [...state.listings.suggestionContactsList],
                customFields: [...getters.customFields]
            }
        },
        getId: () => {},
        getModel: (state, getters) => {
            let model = {
                ...state.opportunitySettings,
                company : {...state.company},
                ...state.paramsSettings,
                contacts: {...state.contacts},
                groupedCustomFields: getters.groupedCustomFields
            }
            return model;
        },
        getRules: (state) =>{
            return state.rules
        },
        getLoading: (state) => {
            return state.loading;
        },
        getType: (state) => {
            return state.type;
        },
        // get Opportunity datas in.opportunitySettings 
        getName: (state) => {
            return state.opportunitySettings.name
        },
        getAmount: (state) => {
            return state.opportunitySettings.amount
        },
        getPercentage: (state) => {
            return state.opportunitySettings.percentage
        },
        getPercentageFunnel: (state) => {
            return state.percentageFunnel
        },
        getSource: (state) => {
            return state.opportunitySettings.source
        },
        getSourceRate: (state) => {
            return state.opportunitySettings.sourceRate
        },
        getDeadline: (state) => {
            return state.opportunitySettings.dealine
        },
        getPipeline: (state) => {
            return state.opportunitySettings.pipeline
        },
        getStep: (state) => {
            return state.opportunitySettings.step
        },
        getSearchAvailable: (state) => {
            return state.modulesSearch;
        },

        // company / third
        getThirdStatus: (state) =>{
            return state.company.created || false;
        },
        getThirdType: (state) =>{
            return (state.company.third === "company" ? "companies" : "individuals");
        },
        getThirdName: (state) => {
            return (!_.isNil(state.company.name) ? state.company.name  : "" );
        },
        getThirdId: (state) => {
            return state.company.id;
        },
        getThird: (state) => {
            return state.company;
        },
        getContact: (state) => (index) =>{
            return state.contacts[index];
        },
        getContacts: (state) => {
            return state.contacts;
        },
        getHasNewItems: (state)=> {
            const contacts = state.contacts?.filter(contact => _.isNil(contact.id));
            return ((contacts.length > 0 && contacts.filter(contact => _.isNil(contact.contactSettings.id))?.length > 0) ||
            (_.isNil(state.company.id) && !_.isNil(state.company.name)));
        },

        // get params data and config
        getParamsConfig: (state) => {
            return {
                ...state.sideParams,
            }
        },
        getNote: (state) => {
            return state.paramsSettings.note
        },
        getIdCode: (state) => {
            return state.paramsSettings.idCode
        },
        getStaff: (state) => {
            return state.paramsSettings.staff
        },
        getOwner: (state) => {
            return state.paramsSettings.owner
        },

        // get listings
        getListings: (state) => {
            return state.listings
        },
        getStaffList: (state) => {
            return state.listings.staffList
        },
        getSuggestionContactsList: (state) => {
            return state.listings.suggestionContactsList
        }

    },
    mutations:{
        ...Third.mutations,
        ...addressMutations,
        setState: (state, payload) => {
            state.opportunitySettings = payload.opportunitySettings;
            state.company = payload.companySettings;
            state.contacts = payload.contacts;
            state.paramsSettings = payload.paramsSettings;
            state.listings.suggestionContactsList = payload.contactsList;

        },
        setForm: (state) =>{
            let defaultState = defaultOpportunityState();
            state.opportunitySettings = defaultState.opportunitySettings;
            state.companySettings = defaultState.company;
            state.contacts = defaultState.contacts;
            state.related = defaultState.related;
            state.id = defaultState.id;
            state.paramsSettings = defaultState.paramsSettings;
        },
        setLoading: (state, payload) => {
            state.loading = payload;
        },
        setName: (state, payload) => {
            state.opportunitySettings.name = payload
        },
        setAmount: (state, payload) => {
            state.opportunitySettings.amount = payload
        },
        setPercentage: (state, payload) => {
            state.opportunitySettings.percentage = payload
        },
        setPercentageFunnel: (state, payload) => {
            state.percentageFunnel = (!_.isNil(payload) ? payload : false)
        },
        setSourceRate: (state, payload) => {
            state.opportunitySettings.sourceRate = payload
        },
        setSource: (state, payload) => {
            state.opportunitySettings.source = payload
        },
        setDealine: (state, payload) => {
            state.opportunitySettings.dealine = payload
        },
        setPipeline: (state, payload) => {
            state.opportunitySettings.pipeline = payload
        },
        setStep: (state, payload) => {
            state.opportunitySettings.step = payload
        },
        setSearchAvailable: (state, payload) => {
            if(!_.isUndefined(payload)){
                state.modulesSearch = payload;
            }
        },

        // company
        setThirdType: (state, payload) => {
            state.company.third = payload;
        },
        setSearchCompanyDatas: (state, payload) => {
            state.company.name = payload.name;
        },
        setThird: (state, payload) => {
            let third = state.company.third;
            state.company = payload;
            state.company.third = third;
        },
        setThirdCustomFields: (state, payload) => {
            state.company.customfields = payload;
        },
        setThirdId: (state, payload) => {
            state.company.id = payload;
        },
        
        setContacts: (state, payload) => {
            state.contacts = payload;
        },
        setContact: (state, payload) => {
            state.contacts.push(payload);
        },
        
        setLegalFrance: (state, payload) => {
            if(_.isNil(state.company.legalSettings)){
                state.company.legalSettings = {};
            }
            state.company.legalSettings.legalFrance = payload;
        },
        setCapital: (state, payload) => {
            if(_.isNil(state.company.legalSettings)){
                state.company.legalSettings = {};
            }
            state.company.legalSettings.capital = payload;
        },

        //set side params
        setNote: (state, payload) => {
            state.paramsSettings.note = payload
        },
        setIdCode: (state, payload) => {
            state.paramsSettings.idCode = payload;
        },
        setStaff: (state, payload) => {
            state.paramsSettings.staff = payload;
        },
        setOwner: (state, payload) => {
            state.paramsSettings.owner = payload;
        },
        
        // set listings
        setLists: (state, payload)=>{
            state.listings = payload;
        },
        setPipelineList: (state, payload) => {
            state.listings.pipelineList = payload
        },
        setStepList: (state, payload) => {
            state.listings.stepList = payload
        },
        setSourceRateList: (state, payload) => {
            state.listings.sourceRateList = payload
        },
        setSourceList: (state, payload) => {
            state.listings.sourceList = payload;
        },
        setStaffList: (state, payload) => {
            state.listings.staffList = payload;
        },
        setSuggestionContactsList: (state, payload) => {
            state.listings.suggestionContactsList = payload
        },
        setSuggestionCompaniesList: (state, payload) =>{},

        clearRelatedObjects: (state) =>{
            let defaultState = defaultOpportunityState();
            state.related = defaultState.related;
        }
    },
    actions:{
        ...Third.actions,
        ...addressActions,
        /**
         * Create or edit company/individual in database.
         * @param {*} param0 
         * @param {*} company (object) 
         * @returns 
         */
        updateCompany: ({state, getters, commit, dispatch}) => {
            let datas = [];
            let thirdUuid = (state.company.edited) ? state.company.id : uuidv4();

            let thirdType = getters.getThirdType;
            
            return new Promise((resolve, reject) => {
                if(state.company.edited || state.company.created){
                    if(state.company.edited){
                        datas.push({"uri": `/${thirdType}/${thirdUuid}`, "method": "PUT"});
                        datas.push(persistThird(state.company));
                    }else{
                        datas.push({"uri": `/${thirdType}`, "method": "POST", "uuid": thirdUuid});
                        datas.push(persistThird(state.company));
                        if (state.addressSection.addresses?.length > 0 && !_.isNil(state.addressSection.addresses[0].settings?.line1) && state.addressSection.addresses[0].settings?.line1 !== "") {
                            commit("setAddressStatus", {value: false, index: 0})
                            dispatch("formatAddressesBeforeSubmit");
                            datas.push({"uri": `/${thirdType}/${thirdUuid}/addresses`, "method": "POST"});
                            datas.push(persistAddresses(state.addressSection.addresses[0]));
                        }
                    }
                    if(state.company.customfields?.length > 0) {
                        datas.push({ "uri": `/${thirdType}/${thirdUuid}/custom-fields`, "method": "PUT" }),
                        datas.push(persistCustomFields(state.company.customfields));
                    }

                    let ndjson = datas.map(JSON.stringify).join('\n');
                    ApiBatchClient.post("/batch", {}, ndjson).then(response => {
                        resolve(response.data.responses[0].response);
                    }).catch((err)=>{
                        reject(err);
                    })
                }else{
                    resolve(false);
                }
            })
        },

        /**
         * Create or edit contact in database and link it to a company if it's a new contact.
         * @param {*} param0 
         * @param {*} contacts (object)
         * @returns 
         */
        updateContact: ({getters}, contacts) => {
            let datas = [];
            const companyId = getters.getThirdId;

            return new Promise((resolve, reject) => {
                if(_.isNil(contacts) || contacts.length <= 0){ resolve(false); }
                contacts.forEach(contact => {

                    if(contact.edited || _.isNil(contact.contactSettings.id)){
                        let contactUuid = (_.isNil(contact.contactSettings.id)) ? uuidv4() : contact.contactSettings.id;
                        let call = null 
                        if (_.isNil(contact.contactSettings.id)){ call = {"uri": `/contacts`, "method": "POST", "uuid": contactUuid}}
                        else { call = {"uri": `/contacts/${contactUuid}`, "method": "PUT"} };
                        
                        datas.push(call);
                        datas.push(ContactApi.persistContactShorten(contact.contactSettings))
    
                        if(contact.customfields?.length > 0) {
                            datas.push({ "uri": `/contacts/${contactUuid}/custom-fields`, "method": "PUT" }),
                            datas.push(persistCustomFields(contact.customfields));
                        }
                        if(_.isNil(contact.id) && getters.getThirdType !== "individuals"){
                            datas.push({"uri": `/companies/${companyId}/contacts/${contactUuid}`, "method": "POST"})
                            datas.push({})
                        }
                    }
                })
                
                if(!_.isNil(datas) && datas.length > 0){
                    let ndjson = datas.map(JSON.stringify).join('\n')
                    ApiBatchClient.post("/batch", {}, ndjson).then((response)=>{
                        let updatedContacts = response.data.responses.filter(res => res.response?.last_name);
                        resolve(updatedContacts.map(contact => contact.response.id));
                    })
                    .catch((err)=>{
                        reject(err)
                    })
                }else{
                    resolve(false)
                }
            })
        },
        updateThird:({state, getters, commit, dispatch}, action)=>{
            let datas = [];
            const uuid = uuidv4();
            return new Promise((resolve, reject) =>{
                dispatch("updateCompany").then(company => {
                    if(company){
                        commit("setThirdId", company.id);
                    }
                    return dispatch("updateContact", getters.getContacts);
                }).then((responseContacts) => {
                    let listedContacts = [...getters.getContacts]
                    let contacts = [];

                    for(let index = 0; index < listedContacts.length; index++){
                        contacts.push(listedContacts[index].contactSettings.id)
                    }
                    if(responseContacts){
                        contacts = contacts.concat(responseContacts);
                    }
                    //remove duplication
                    contacts = contacts.filter((item,index)=>{
                        return (contacts.indexOf(item) == index)
                     }).filter((item)=>{
                        return (!_.isNil(item))
                     })

                    //format related datas (contact)
                    if(contacts.length > 0) {
                        state.related.staff = [...contacts];
                    }else{
                        state.related.staff = [];
                    }
                }).then(() => {
                    //format related datas (company)
                    state.related.company.push({id : getters.getThird.id, type: state.company.third})
                    
                    //persist opportunity datas
                    datas.push({"uri": "/opportunities", "method": "POST", "uuid": uuid});
                    datas.push(persistOpportunity(state));

                    //persist custom fields datas
                    if(getters.customFields.length) {
                        datas.push({ "uri": `/opportunities/${uuid}/custom-fields`, "method": "PUT" }),
                        datas.push(persistCustomFields(getters.customFields));
                    }

                    let ndjson = datas.map(JSON.stringify).join('\n');
                    
                    ApiBatchClient.post("/batch", {}, ndjson).then((res)=>{
                        //success
                        if(!res.data.error){
                            if(action && action !== ""){
                                dispatch("clearThird")
                            }
                            Push.success(window.i18n.__('Opportunité ajoutée avec succès'));
                            resolve({id: res.data.responses[0].response.id})

                        }else{
                            //fail
                            commit("clearRelatedObjects")
                            reject(res.data.responses.find(response => response.code >= 400));
                        }
                    }).catch(err =>{
                        //fail
                        commit("clearRelatedObjects")
                        reject(err);
                    })
                }).catch(err => {
                    commit("clearRelatedObjects")
                    reject(err);
                });
            })
        },

        /**
         * Recover datas of the pending form 
         * @param {} store : recover saved store
         */
        fetchPendingStore: ({commit}, store) =>{
            let contacts = store.state.contacts;
            //if new data is new contact
            if(store.new && store.newDatas?.datas?.contact){
                contacts.push({
                    contactSettings : store.newDatas.datas.contact,
                    id : store.newDatas.datas.id
                })
                store.state.contacts = contacts
            }
            commit("setState", store.state)
        },
        
        fetchMetadata: ({ commit }) =>{
            return new Promise((resolve, reject) => {
                ApiClient.get("/opportunities/metadata", {}).then((res)=>{
                    //search is available 
                    commit("setSearchAvailable", res.data.firmsearch)

                    commit("setPercentageFunnel", res.data.use_proba_funnel)

                    let sourceCats = res.data.categories
                    sourceCats.forEach(cat => {
                        if (!_.isNil(cat.sources) && cat.sources.length > 0){
                            cat.disabled = false;
                        }else{
                            cat.disabled = true;
                        }
                    })
                    commit(`setSourceRateList`, sourceCats);

                    for(let indexCategory = 0; indexCategory < sourceCats.length; indexCategory++){
                        let category = sourceCats[indexCategory];
                        if (category.sources){
                            for(let indexSource = 0; indexSource < category.sources.length; indexSource++){
                                if(!!category.sources[indexSource].default){
                                    commit("setSourceRate", category);
                                    commit(`setSourceList`, category.sources);
                                    commit("setSource", category.sources[indexSource]);
                                    break;
                                }
                            }
                        }
                    }

                    commit(`setPipelineList`, res.data.pipelines);
                    //set the item with default value as true as the default value in list
                    let defaultItem = res.data.pipelines.find(pipeline => !!pipeline.default)
                    if(!_.isNil(defaultItem)){
                        commit("setPipeline", defaultItem)
                        commit(`setStepList`, defaultItem.steps);
                    }

                    commit(`setIdCode`, res.data.next_ident);
                    commit(`setStaffList`, res.data.staffs);
                    resolve();

                }).catch( err => {
                    reject(err);
                })
            });
        },
        fetchThirdCustomFields: ({getters}, id) => {
            let third = getters.getThirdType;
            return new Promise ((resolve, reject) => {
                ApiClient.get(`/${third}/${id}/custom-fields`).then((cfs) => {
                    resolve(cfs?.data?.data.filter(cf => !!cf.mandatory))
                }).catch(err=>{
                    reject();
                })
            })
        },

        fetchContactCustomField: ({}, contact) => {
            return new Promise ((resolve, reject) => {
                ApiClient.get(`/contacts/${contact}/custom-fields`).then((cfs) => {
                    resolve(cfs?.data?.data.filter(cf => !!cf.mandatory))
                }).catch(err=>{
                    reject();
                })
            })
        },

        fetchContacts: ({commit, dispatch}, company) => {
            return new Promise((resolve, reject)=>{
                let mainContact = null;
                CompanyApi.getCompanyById(company.id).then((res) => {
                    //no assigned contact to the current company
                    if(_.isNil(res.data.main_contact_id)){
                        resolve(false);
                    }else{
                        mainContact = res.data.main_contact_id
                        CompanyApi.getCompanyContact(company.id).then((res)=>{
                            let contactsList = []
                            res.data.data.filter(contact => contact.id !== mainContact).forEach(contact =>{
                                let contactData = {
                                    name : contact.last_name,
                                    forename : contact.first_name,
                                    role: contact.position,
                                    id: contact.id,
                                    email: contact.email
                                };
                                contactsList.push(contactData);
                            });
                            commit("setSuggestionContactsList", contactsList);
                        
                            //set main contact as default value in contacts
                            let mainContactSettings = res.data.data.find(contact => contact.id === mainContact)
                            dispatch("fetchContactCustomField", mainContactSettings.id).then((cfs) => {
                                mainContactSettings.customfields = cfs;
                                commit("setContact", formatContact(mainContactSettings))
                                resolve(true)
                            })
                        }).catch((err) => {
                            reject(err);
                        })
                    }
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        
        removeSuggestionContact: ({state}, index) =>{
            state.listings.suggestionContactsList.splice(index, 1);
        },

        addThird:({commit, getters, dispatch}, data) => {
            if(data.type === "contact"){
                dispatch("addContact", data.datas)
            }else{
                let formatedData = {
                    id: data.datas.settings.id,
                    name: data.datas.settings.name,
                    type: data.datas.settings.type,
                    address: data.datas.settings.address,
                    customfields: data.datas.customfields
                };
                if(!_.isNil(formatedData.id)){
                    formatedData.edited = true;
                }else{
                    formatedData.created = true;
                }

                 if(getters.getThirdType === "individuals"){
                    formatedData.civility = data.datas.settings.civility;
                    formatedData.forename = data.datas.settings.forename;
                }
              commit("setThird", formatedData);
            }
        },

        /**
         * Only available for contact, because the other type of third only overwrite on third datas 
         * @param {*} param0 
         * @param {*} third 
         */
        editThird: ({state}, third) =>{
            if(!_.isNil(third.index)){
                state.contacts[third.index].contactSettings = {
                    email: third.datas.settings.email,
                    forename:  third.datas.settings.forename,
                    name: third.datas.settings.name,
                    role: third.datas.settings.role
                }
                state.contacts[third.index].customfields = third.datas.customfields;
                if (!_.isNil(third.datas.settings.id)){
                    state.contacts[third.index].contactSettings.id = third.datas.settings.id;
                    state.contacts[third.index].edited = true;
                }
            }
        },
        
        addContact: ({state}, third) =>{
            let contact = {
                contactSettings:{
                    email: third.settings.email,
                    forename: third.settings.forename,
                    name: third.settings.name,
                    role: third.settings.role,
                    id: null
                },
                imported: third.imported,
                id: third.settings.id,
            };
            if(third.customfields?.length > 0){
                contact.customfields = third.customfields;
            }
            state.contacts.push(contact);

            //if isn't a created contact, remove it from suggestion list
            if((!!third.settings.id && !_.isNil(third.index)) || !!third.imported){
                state.listings.suggestionContactsList.splice(third.index, 1);
            }
        },

        removeContact: ({state}, index) =>{
            let contact = {
                forename : state.contacts[index].contactSettings.forename,
                name : state.contacts[index].contactSettings.name,
                role : state.contacts[index].contactSettings.role,
                email : state.contacts[index].contactSettings.email,
                id : state.contacts[index].contactSettings.id,
                customfields : state.contacts[index].customfields,
            }
            if(!_.isNil(state.contacts[index].contactSettings.id) || !_.isNil(state.contacts[index].imported)){
                state.listings.suggestionContactsList.push(contact)
            }
            state.contacts.splice(index, 1);
        },

        resetCompany: ({ commit }) => {
            return new Promise ((resolve, reject) => {
                commit("setThird", {name:null})
                commit("setSuggestionContactsList", [])
                commit("setSuggestionCompaniesList", [])
                commit("setContacts", []);
                resolve();
            })
        },

        commitSteps:({commit}, payload) =>{
            commit(`setStep`, {})
            commit(`setStepList`, payload.steps);
            //set the object with is_default as true as the default value in selector
            let defaultValue = payload.steps.find(find => find.default);
            if(!_.isNil(defaultValue)){
                commit(`setStep`, defaultValue)
                commit(`setPercentage`, defaultValue.proba)
            }
        },

        commitSourceRate:({commit}, payload) => {
            commit(`setSource`,{});

            let list = payload.sources.filter(source => !source.is_hidden)
            commit(`setSourceList`, list);

            //set the object with is_default as true as the default value in selector
            for(let index = 0; index < list.length; index++){
                if (payload.sources[index].default){
                    commit(`setSource`, payload.sources[index]);
                    break;
                }
            }
        },
        commitCompanyAddress({state, getters}){
            let settings = getters.getAddresses[0]?.settings;
            if(!_.isNil(settings)){
                state.company.address = {
                    postal_code: settings.postalCode,
                    city: settings.city
                }
            }
        },

        clearThird:({state, commit, dispatch}) =>{
            let searchAvailable = state.modulesSearch;
            commit("setForm");
            dispatch("resetCompany");
            dispatch("fetchMetadata");
            commit("setSearchAvailable", searchAvailable);
        }
    }
}